<style src="./DocumentType.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="permission">
    <content-header path="Cadastro / Tipo de Documento"/>

    <form v-on:submit.prevent>
      <section class="form-box row">
        <textbox
          class="col-9"
          debounce="300"
          @debounce="loadAll"
          v-model="searchText"
          placeholder="Busca o produto que deseja"
          label="Produto" />

        <button class="btn-primary col-3" @click="addNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <document-type-map
        :list-data="listData"
        @edit="edit"
        @refresh-list="loadAll"/>
    </section>

    <right-side-panel
      ref="rspNew"
      title="Novo Tipo de Documento"
      v-shortkey="['ctrl', 'alt', 'n']"
      width="620px"
      :outsideClose="false"
      @shortkey="addNew">
      <new-document-type />
    </right-side-panel>

    <right-side-panel
      :outsideClose="false"
      width="620px"
      ref="rspEdit" title="Editar Tipo de Documento">
      <edit-document-type
        :edit-data="editData" />
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { Textbox } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { DocumentTypeMap } from './components'
import NewDocumentType from './components/new-document-type/NewDocumentType'
import EditDocumentType from './components/edit-document-type/EditDocumentType'
import { mapGetters } from 'vuex'

export default {
  name: 'User',
  components: {
    ContentHeader,
    RightSidePanel,
    Textbox,
    IconAdd,
    IconEmpty,
    DocumentTypeMap,
    NewDocumentType,
    EditDocumentType
  },
  data () {
    return {
      searchText: '',
      editData: {},
      showNewRightPanel: false
    }
  },
  computed: {
    ...mapGetters({
      listData: 'DocumentType/LIST'
    })
  },
  mounted () {
    this.loadAll()
  },
  methods: {
    async loadAll () {
      const form = {
        searchText: this.searchText
      }
      await this.$store.dispatch('DocumentType/LIST_PAGINATED', form)
    },
    addNew () {
      this.$nextTick(() => {
        this.$refs.rspNew.showPanel()
      })
    },
    addedSuccessful () {
      this.showNewRightPanel = false
      this.loadAll()
    },
    edit (pId) {
      this.editData = this.listData[pId]
      this.$nextTick(() => {
        this.$refs.rspEdit.showPanel()
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/record/document-type/DocumentType.vue